import React, { useState } from "react";
import { Card, Button, Modal, Form, Dropdown } from "react-bootstrap";
import { FiTrash2, FiPlus } from "react-icons/fi";

export default function CallsTab() {
  const [showModal, setShowModal] = useState(false);
  const [calls, setCalls] = useState([
    {
      id: 1,
      name: "Darlee Robertson",
      time: "23 Jul 2023, 10:00 pm",
      status: "Busy",
      note: "A project review evaluates the success of an initiative.",
    },
    {
      id: 2,
      name: "Sharon Roy",
      time: "28 Jul 2023, 09:00 pm",
      status: "No Answer",
      note: "A project plan typically contains essential elements.",
    },
  ]);

  const [form, setForm] = useState({
    status: "Busy",
    date: "",
    note: "",
  });

  const statusOptions = [
    "Busy",
    "No Answer",
    "Unavailable",
    "Wrong Number",
    "Left Voice Message",
    "Moving Forward",
  ];

  // ADD CALL
  const handleSave = () => {
    const newCall = {
      id: Date.now(),
      name: "New Contact",
      time: form.date,
      status: form.status,
      note: form.note,
    };

    setCalls([newCall, ...calls]);
    setShowModal(false);
    setForm({ status: "Busy", date: "", note: "" });
  };

  // DELETE
  const handleDelete = (id) => {
    setCalls(calls.filter((c) => c.id !== id));
  };

  // STATUS CHANGE
  const updateStatus = (id, status) => {
    setCalls(
      calls.map((c) => (c.id === id ? { ...c, status } : c))
    );
  };

  return (
    <>
      {/* 🔥 INTERNAL CSS */}
      <style>{`
        .call-card {
          border: 1px solid #eee;
          border-radius: 8px;
          padding: 15px;
          margin-bottom: 12px;
        }
          .notes-wrapper{
  
              align-items: center;
          border: 1px solid #eee;
          padding: 10px;
          border-radius: 6px;
          background:#ffffff;

       }

        .call-header {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 10px;
        }

        .call-name {
          font-weight: 600;
          font-size: 14px;
        }

        .call-note {
          font-size: 13px;
          color: #666;
          margin-top: 5px;
        }

        .status-btn {
          font-size: 12px;
          border-radius: 6px;
          padding: 4px 10px;
        }

        
        .status-btn:hover {
           border-color: #f97316 !important;
          color: #f97316 !important;
           background: #f9fafb;
          border: 1px solid #e5e7eb;

        }
        .status-busy {
          background: #ffe4e6;
          color: #dc2626;
        }

        .status-noanswer {
          background: #f3e8ff;
          color: #7c3aed;
        }

        .dropdown-menu .dropdown-item.active,
        .dropdown-menu .dropdown-item:active {
          background: #ff6a00 !important;
          color: #fff;
        }

        .add-btn {
          color: #ff6a00;
          font-weight: 500;
          cursor: pointer;
        }
             .add-btn:hover {
          border-color: #f97316 !important;
          color: #f97316 !important;
           background: #f9fafb;
          border: 1px solid #e5e7eb;

        }

        .modal-footer .btn-save {
          background: #ff6a00;
          color: #fff;
        }

        /* MOBILE */
        @media(max-width:768px){
          .call-header{
            flex-direction: column;
            align-items: flex-start;
          }
        }
      `}</style>

      {/* HEADER */}
      <div className="d-flex notes-wrapper justify-content-between align-items-center p-3">
        <h5>Calls</h5>
        <div className="add-btn" onClick={() => setShowModal(true)}>
          <FiPlus /> Add New
        </div>
      </div>

      {/* LIST */}
      <div className="p-3">
        {calls.map((call) => (
          <div className="call-card" key={call.id}>
            <div className="call-header">
              <div>
                <div className="call-name">
                  {call.name} logged a call on {call.time}
                </div>
              </div>

              <div className="d-flex align-items-center gap-2">
                {/* STATUS */}
                <Dropdown>
                  <Dropdown.Toggle
                    className={`status-btn ${
                      call.status === "Busy"
                        ? "status-busy"
                        : "status-noanswer"
                    }`}
                  >
                    {call.status}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    {statusOptions.map((s) => (
                      <Dropdown.Item
                        key={s}
                        active={call.status === s}
                        onClick={() => updateStatus(call.id, s)}
                      >
                        {s}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>

                {/* DELETE */}
                <FiTrash2
                  style={{ cursor: "pointer" }}
                  onClick={() => handleDelete(call.id)}
                />
              </div>
            </div>

            <div className="call-note">{call.note}</div>
          </div>
        ))}
      </div>

      {/* MODAL */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Create Call Log</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <div className="mb-3">
              <Form.Label>Status *</Form.Label>
              <Form.Select
                value={form.status}
                onChange={(e) =>
                  setForm({ ...form, status: e.target.value })
                }
              >
                {statusOptions.map((s) => (
                  <option key={s}>{s}</option>
                ))}
              </Form.Select>
            </div>

            <div className="mb-3">
              <Form.Label>Followup Date *</Form.Label>
              <Form.Control
                type="date"
                value={form.date}
                onChange={(e) =>
                  setForm({ ...form, date: e.target.value })
                }
              />
            </div>

            <div className="mb-3">
              <Form.Label>Note *</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={form.note}
                onChange={(e) =>
                  setForm({ ...form, note: e.target.value })
                }
              />
            </div>

            <Form.Check label="Create a follow up task" />
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="light" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button className="btn-save" onClick={handleSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}